import Header from './components/Header';
import Hero from './components/Hero';
import CarouselSection from './components/CarouselSection';
import ContactSection from './components/ContactSection';
import AboutSection from './components/AboutSection';
import TopicsSection from './components/TopicsSection';
import IndexSection from './components/IndexSection';
import CommentsSection from './components/CommentsSection';
import RankingSection from './components/RankingSection';
import FaqSection from './components/FaqSection';
import MediaSection from './components/MediaSection';
import CardsSection from './components/CardsSection';
import AppSection from './components/AppSection';
import FeaturesSection from './components/FeaturesSection';
import UpdatesSection from './components/UpdatesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <CarouselSection />
        <ContactSection />
        <AboutSection />
        <TopicsSection />
        <IndexSection />
        <CommentsSection />
        <RankingSection />
        <FaqSection />
        <MediaSection />
        <CardsSection />
        <AppSection />
        <FeaturesSection />
        <UpdatesSection />
      </main>
      <Footer />
    </>
  );
}